export const getPaypalMode = (): 'LIVE' | 'SANDBOX' => {
  const PAYPAL_MODE = process.env.REACT_APP_PAYPAL_MODE as string;
  return PAYPAL_MODE === 'LIVE' || PAYPAL_MODE === 'SANDBOX'
    ? PAYPAL_MODE
    : 'SANDBOX';
};
